// import $public from '../../util/public.js'
export default {
	namespaced: true,
	state: {
		type:'list',
		addParams:{},
		curRow:{},
		money:0,
		activityMoney:0,
		remark:'',
		curDiscountCard:null,
	},
	getters: {
		
	},
	mutations: {
		set_type(state, params) {
			state.type = params;
		},
		set_addParams(state, obj) {
			state.addParams = obj;
		},
		set_curRow(state, obj) {
			state.curRow = obj;
		},
		set_money(state, params) {
			state.money = params;
		},
		set_activityMoney(state, params) {
			console.log(params)
			state.activityMoney = params;
		},
		set_remark(state, obj) {
			state.remark = obj;
		},
		set_curDiscountCard(state, obj) {
			state.curDiscountCard = obj;
		},
	},
	actions: {

	},
};
